// extracted by mini-css-extract-plugin
module.exports = {"card":"Statements_card__1j6u7"};